import { createReducer } from "@reduxjs/toolkit";
import initialState from "./initialState";
import * as types from "../types/actions";
import { action } from "@storybook/addon-actions";
import moment from "moment";
import _ from "lodash";

const virReducer = createReducer(initialState.vir, {
  [types.ATHENA_AUTH]: (state) => ({
    ...state,
    athenaAuth: {
      ...state.athenaAuth,
      loading: true,
    },
  }),
  [types.ATHENA_AUTH_SUCCESS]: (state, action) => ({
    ...state,
    athenaAuth: {
      ...action.response,
      expires: moment().add(15, "m").unix(),
      loading: false,
    },
  }),
  [types.ATHENA_AUTH_FAILURE]: (state, error) => ({
    ...state,
    athenaAuth: {
      message: error.error.message,
      loading: false,
    },
  }),

  [types.ATHENA_VIR_AUTH]: (state) => ({
    ...state,
    athenaVirAuth: {
      ...state.athenaVirAuth,
      loading: true,
    },
  }),

  [types.ATHENA_VIR_AUTH_SUCCESS]: (state, action) => ({
    ...state,
    athenaVirAuth: {
      ...action.response,
      loading: false,
    },
  }),

  [types.ATHENA_VIR_AUTH_FAILURE]: (state, error) => ({
    ...state,
    athenaVirAuth: {
      error,
      loading: false,
    },
  }),

  [types.ATHENA_LOGOUT]: (state, error) => ({
    ...state,
    ...initialState.vir,
  }),

  [types.ATHENA_INIT_APP_SMS]: (state, error) => ({
    ...state,
    ...initialState.vir,
    athenaApp: {
      loading: true,
    },
  }),

  [types.ATHENA_PHOTOS_CLEANUP]: (state, error) => ({
    ...state,
    virPrepareTHERMEON: {},
  }),

  [types.ATHENA_EXTEND_SESSION]: (state, error) => ({
    ...state,
    athenaAuth: {
      ...state.athenaAuth,
      expires: state.athenaAuth.expires + 30 * 60,
    },
  }),

  [types.ATHENA_VIR_PREPARE_BE]: (state, action) => ({
    ...state,
    virPrepareBE: {
      ...state.virPrepareBE,
      ...action.payload,
    },
  }),

  [types.ATHENA_VIR_PREPARE_THERMEON]: (state, action) => ({
    ...state,
    virPrepareTHERMEON: {
      ...state.virPrepareTHERMEON,
      ...action.payload,
    },
  }),

  [types.ATHENA_VIR_WINDSCREEN]: (state, action) => ({
    ...state,
    virPrepareBE: {
      ...state.virPrepareBE,
      ...action.payload,
    },
    selectedSource: "windscreenOrTyre",
  }),
  [types.ATHENA_VIR_PANEL]: (state, action) => ({
    ...state,
    virPrepareBE: {
      ...state.virPrepareBE,
      ...action.payload,
    },
    selectedSource: "panelOrAccident",
  }),
  // for user
  [types.VIR_SEND_CONTACT]: (state) => ({
    ...state,
    virSendContact: {
      loading: true,
    },
  }),
  [types.VIR_RESET_CONTACT]: (state) => ({
    ...state,
    virSendContact: {
      loading: false,
      success: undefined,
    },
  }),

  [types.VIR_SEND_CONTACT_SUCCESS]: (state, action) => ({
    ...state,
    virSendContact: {
      loading: false,
      success: true,
    },
  }),

  [types.VIR_SEND_CONTACT_FAILURE]: (state, error) => ({
    ...state,
    virSendContact: {
      loading: false,
      error,
      success: false,
    },
  }),
  // for user
  [types.VIR_SEND_CONTACT]: (state) => ({
    ...state,
    virSendContact: {
      loading: true,
    },
  }),
  [types.VIR_RESET_CONTACT]: (state) => ({
    ...state,
    virSendContact: {
      loading: false,
      success: undefined,
    },
  }),

  [types.VIR_SEND_CONTACT_SUCCESS]: (state, action) => ({
    ...state,
    virSendContact: {
      loading: false,
      success: true,
    },
  }),

  [types.VIR_SEND_CONTACT_FAILURE]: (state, error) => ({
    ...state,
    virSendContact: {
      loading: false,
      error,
      success: false,
    },
  }),
  // for user
  [types.ATHENA_VIR_USER]: (state) => ({
    ...state,
    athenaVirUser: {
      ...state.athenaVirUser,
      loading: true,
    },
  }),

  [types.ATHENA_VIR_USER_SUCCESS]: (state, action) => ({
    ...state,
    athenaVirUser: {
      ...action.response,
      loading: false,
    },
  }),

  [types.ATHENA_VIR_USER_FAILURE]: (state, error) => ({
    ...state,
    athenaVirUser: {
      error,
      loading: false,
    },
  }),

  // for servicetracking
  // for user
  [types.ATHENA_VIR_SERVICETRACKING]: (state) => ({
    ...state,
    athenaVirServiceTracking: {
      ...state.athenaVirServiceTracking,
      loading: true,
    },
  }),

  [types.ATHENA_VIR_SERVICETRACKING_SUCCESS]: (state, action) => ({
    ...state,
    athenaVirServiceTracking: {
      ...action.response,
      loading: false,
    },
  }),

  [types.ATHENA_VIR_SERVICETRACKING_FAILURE]: (state, error) => ({
    ...state,
    athenaVirServiceTracking: {
      error,
      loading: false,
    },
  }),

  // detail
  [types.ATHENA_VIR_DETAIL]: (state) => ({
    ...state,
    athenaVirDetail: {
      ...state.athenaVirDetail,
      loading: true,
    },
  }),

  [types.ATHENA_VIR_DETAIL_SUCCESS]: (state, action) => ({
    ...state,
    athenaVirDetail: {
      ...action.response,
      loading: false,
    },
  }),

  [types.ATHENA_VIR_DETAIL_FAILURE]: (state, error) => ({
    ...state,
    athenaVirDetail: {
      ...state.athenaVirDetail,
      error,
      loading: false,
    },
  }),

  //for detail patch
  [types.ATHENA_VIR_DETAIL_PATCH]: (state) => ({
    ...state,
    athenaVirDetailPatch: {
      ...state.athenaVirDetailPatch,
      loading: true,
    },
  }),

  [types.ATHENA_VIR_DETAIL_PATCH_SUCCESS]: (state, action) => ({
    ...state,
    athenaVirDetailPatch: {
      ...action.payload,
      loading: false,
    },
  }),

  [types.ATHENA_VIR_DETAIL_PATCH_FAILURE]: (state, error) => ({
    ...state,
    athenaVirDetailPatch: {
      ...state.athenaVirDetailPatch,
      error,
      loading: false,
    },
  }),

  // for init the status
  // [types.ATHENA_VIR_INTIALIZE]: (state) => ({
  //   ...state,
  //   athenaVirInitialize: {
  //     ...state.athenaVirInitialize,
  //   },
  // }),

  // [types.ATHENA_VIR_INTIALIZE_SUCCESS]: (state, action) => ({
  //   ...state,
  //   athenaVirInitialize: {
  //     ...action.response,
  //     loading: false,
  //   },
  // }),

  // [types.ATHENA_VIR_INTIALIZE_FAILURE]: (state, error) => ({
  //   ...state,
  //   athenaVirInitialize: {
  //     error,
  //     loading: false,
  //   },
  // }),

  [types.SEARCHADDRESS_SUCCESS]: (state, action) => {
    const addressSuggestions = [];
    _.get(action, "response.data.KleberDataValidation.AddressResult", []).forEach((address) => {
      if (
        _.get(action, "response.data.KleberDataValidation.International", false) &&
        (_.get(action, "response.data.KleberDataValidation.SuggestionCountry", "") != "AU" ||
          _.get(action, "response.data.KleberDataValidation.SuggestionCountry", "") != "NZ")
      ) {
        addressSuggestions.push({
          label: _.get(address, "AddressLine", ""),
          value: _.get(address, "RecordId", null),
        });
      } else if (
        _.get(action, "response.data.KleberDataValidation.SuggestionCountry", "") == "NZ"
      ) {
        addressSuggestions.push({
          label:
            _.get(address, "AddressLine", "") +
            "," +
            _.get(address, "Suburb", "") +
            "," +
            _.get(address, "TownCityMailtown", "") +
            "," +
            _.get(address, "Postcode", ""),
          value: _.get(address, "RecordId", null),
        });
      } else if (
        _.get(action, "response.data.KleberDataValidation.SuggestionCountry", "") == "AU"
      ) {
        addressSuggestions.push({
          label:
            _.get(address, "AddressLine", "") +
            "," +
            _.get(address, "Locality", "") +
            "," +
            _.get(address, "Postcode", "") +
            "," +
            _.get(address, "State", "") +
            "," +
            "AU",

          value: _.get(address, "RecordId", null),
        });
      }
    });
    return {
      ...state,
      addressSuggestions: addressSuggestions,
    };
  },

  // for damage presigned the status
  [types.ATHENA_DAMAGE_PRESIGNED]: (state) => ({
    ...state,
    athenaDamagePresigned: {
      ...state.athenaDamagePresigned,
      loading: true,
    },
  }),

  [types.ATHENA_DAMAGE_PRESIGNED_SUCCESS]: (state, action) => ({
    ...state,
    athenaDamagePresigned: {
      ...action.response,
      loading: false,
    },
  }),

  [types.ATHENA_DAMAGE_PRESIGNED_FAILURE]: (state, error) => ({
    ...state,
    athenaDamagePresigned: {
      error,
      loading: false,
    },
  }),
  // for the zip photos
  [types.ATHENA_DAMAGE_PHOTO_ZIP]: (state) => ({
    ...state,
    athenaDamageZipPhotos: {
      ...state.athenaDamageZipPhotos,
      loading: true,
    },
  }),

  [types.ATHENA_DAMAGE_PHOTO_ZIP_SUCCESS]: (state, action) => ({
    ...state,
    athenaDamageZipPhotos: {
      ...action.response,
      loading: false,
    },
  }),

  [types.ATHENA_DAMAGE_PHOTO_ZIP_FAILURE]: (state, error) => ({
    ...state,
    athenaDamageZipPhotos: {
      error,
      loading: false,
    },
  }),

  //for the create review page
  [types.ATHENA_VIR_CREATE]: (state) => ({
    ...state,
    athenaVirCreate: {
      ...state.athenaVirCreate,
      loading: true,
    },
  }),

  [types.ATHENA_VIR_CREATE_SUCCESS]: (state, action) => ({
    ...state,
    athenaVirCreate: {
      ...action.payload,
      loading: false,
    },
  }),

  [types.ATHENA_VIR_CREATE_FAILURE]: (state, error) => ({
    ...state,
    athenaVirCreate: {
      error,
      loading: false,
    },
  }),
  [types.RETRIEVEADDRESS_SUCCESS]: (state, action) => {
    return {
      ...state,
      selectedAddress: {
        address: _.get(
          action,
          "response.data.KleberDataValidation.AddressResult[0]",
          initialState.checkin.selectedAddress
        ),
        selectedCountry: _.get(
          action,
          "response.data.KleberDataValidation.SuggestionCountry",
          initialState.checkin.selectedAddress
        ),
      },
    };
  },
  [types.RESET_ADDRESS_SEARCH]: (state, action) => {
    if (state.addressSuggestions) {
      delete state.addressSuggestions;
    }
    return state;
  },
  [types.ATHENA_VIR_DELETE]: (state, action) => ({
    ...state,
    athenaVirServiceTracking: {
      ...state.athenaVirServiceTracking,
      data: {
        virs: {
          windscreen: state.athenaVirServiceTracking.data.virs.windscreen.filter(
            (vir) => vir.virid !== action.payload.virid
          ),
          panel: state.athenaVirServiceTracking.data.virs.panel.filter(
            (vir) => vir.virid !== action.payload.virid
          ),
          theft: state.athenaVirServiceTracking.data.virs.theft.filter(
            (vir) => vir.virid !== action.payload.virid
          ),
        },
      },
    },
  }),
  [types.ATHENA_VIR_RESUBMIT]: (state, action) => ({
    ...state,
    athenaVirResubmit: {
      virId: action.payload.virId,
      flag: action.payload.flag,
    },
  }),

  [types.ATHENA_VIR_CLEAN]: (state, action) => ({
    ...state,
    athenaVirDetailPatch: {
      loading: false,
    },
  }),

  [types.ATHENA_SELECTED_TYPE]: (state, action) => ({
    ...state,
    athenaSelectedType: {
      selectedType: action.payload.selectedType,
    },
  }),
  [types.ATHENA_SELECTED_TYPE]: (state, action) => ({
    ...state,
    athenaSelectedType: {
      selectedType: action.payload.selectedType,
    },
  }),

  [types.ATHENA_SELECTED_ID]: (state, action) => ({
    ...state,
    athenaSelectedId: {
      selectedId: action.payload.selectedId,
    },
  }),

  [types.ATHENA_APP_LOADING]: (state, action) => ({
    ...state,
    athenaApp: {
      loading: action.payload.loading,
    },
  }),

  [types.ATHENA_SOURCE]: (state, action) => ({
    ...state,
    athenaSource: {
      source: action.payload.source,
    },
  }),
  [types.ATHENA_REPORT_TYPE]: (state, action) => ({
    ...state,
    athenaReportType: {
      reportType: action.payload.reportType,
    },
  }),
  [types.ATHENA_ROLE]: (state, action) => ({
    ...state,
    athenaRole: {
      role: action.payload.role,
    },
  }),
});

export default virReducer;
